import React from 'react';
import BaseModule from '../../logic/module/BaseModule';
import { AppRoute } from '../../components';

export const NAME = 'fx';

export default class FxRatesModule extends BaseModule {
  getName() {
    return NAME;
  }

  getPermission() {
    return 'fx.*';
  }

  getPolicy() {
    return 'Admin:FX:View:*';
  }

  getNavigation() {
    return [
      {
        label: 'FX Rates',
        icon: 'retweet',
        path: '/fx-rates',
        permission: 'fx.*',
        policy: 'Admin:FX:View:*'
      }
    ];
  }

  getRoutes(currentUrl = '') {
    return [
      <AppRoute
        path={`${currentUrl}fx-rates`}
        load={() => import('./FxRates')}
      />
    ];
  }
}
